import { MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT } from './payment-constants';

export const MAX_BANK_ACCOUNT_CHANGE = 9999999;
export const MAX_TRANSACTION_AMOUNT = 99999.99;
export const MAX_TRANSACTION_AMOUNT_IN_CENTS = Math.round(
  MAX_TRANSACTION_AMOUNT * 100
);

export const MAX_RECEIPT_BATCH_AMOUNT_IN_CENTS =
  MAX_SERVICE_PROVIDER_STRIPE_PAYMENT_CENT_AMOUNT;

// Stripe caps a receipt batch at 10k€ (the per-transfer Stripe limit). MangoPay
// pays receipts individually with no batch-level cap, so the Mangopay branch is
// effectively unlimited — per-entry caps still apply at upstream validators
// (e.g. MAX_TRANSACTION_AMOUNT_IN_CENTS @Max on transaction DTOs).
//
// The unlimited branch is gated on an explicit 'mangopay' match, not used as the
// fallback: any unexpected value (e.g. an unknown/mis-cased processor arriving
// through an `as` cast) falls through to the Stripe cap, so the safe direction
// is to keep the limit rather than silently remove it.
export function getMaxReceiptBatchAmountInCents(
  paymentProcessor: 'stripe' | 'mangopay'
): number {
  return paymentProcessor === 'mangopay'
    ? Number.MAX_SAFE_INTEGER
    : MAX_RECEIPT_BATCH_AMOUNT_IN_CENTS;
}

export const MAX_ENTRY_TOTAL_AMOUNT_FOR_RECEIPT_GENERATION_IN_CENTS = 40000;
